<template>
  <v-container>

    <stock-result
        v-if="done"
        :remove-transaction="removeTransaction"
    />

    <v-row v-else>
      <v-col cols="12" class="text-right">
        <v-text-field
          v-model="reason"
          label="Motivo" placeholder="Motivo"
          outlined
          />
      </v-col>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            v-model="item.subtract"
            :in-stock="item.quantity"
            :minimum="item.minimum"
            validate-stock
        >
        </product-stock>
      </v-col>
      <v-col cols="12" class="text-right">
        <submit-button @click="removeStock"></submit-button>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";
import {SubmitButton} from '@dracul/common-frontend'
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";
import StockResult from "@/modules/delivery/pages/stock/StockOperationPage/StockResult/StockResult";

export default {
  name: "StockRemove",
  components: {StockResult, ProductStock, SubmitButton},
  props: {
    stock: Object,
  },
  data() {
    return {
      items: [],
      removeTransaction: null,
      done: false,
      reason: ''
    }
  },
  computed:{
    getItems(){
      return this.stock.items.filter(i => i.hide === false)
    },
    getRemoveItems(){
      return this.stock.items.filter(i => i.subtract > 0).map(i=> ({product: i.product.id, quantity:i.subtract}))
    },
  },
  methods: {
    removeStock() {
      StockOperationProvider.removeStockOperation(this.stock.id, this.getRemoveItems, this.reason)
      .then((r)=> {
        console.log(r.data.removeStockOperation)
        this.removeTransaction = r.data.removeStockOperation
        this.done = true
        this.$emit('stockRemoved',r)
      })
    }
  }
}
</script>

<style scoped>

</style>
